import createIcon from '../../createIcon';

/**
 * @component @name FormatColorReset
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguMDY5OCAxMy44MzUyQzE4LjA2OTggOS44MzUxNiAxMi4wNjk4IDMuMDM1MTYgMTIuMDY5OCAzLjAzNTE2QzEyLjA2OTggMy4wMzUxNiAxMC43Mzk4IDQuNTQ1MTYgOS4zMzk4MiA2LjU1NTE2TDE3LjkyOTggMTUuMTQ1MkMxOC4wMTk4IDE0LjcyNTIgMTguMDY5OCAxNC4yODUyIDE4LjA2OTggMTMuODM1MlpNNS4zMzk4MiA1LjEwNTE2TDQuMDY5ODIgNi4zODUxNkw3LjM4OTgyIDkuNzA1MTZDNi42MTk4MiAxMS4xNTUyIDYuMDY5ODIgMTIuNjI1MiA2LjA2OTgyIDEzLjgzNTJDNi4wNjk4MiAxNy4xNDUyIDguNzU5ODIgMTkuODM1MiAxMi4wNjk4IDE5LjgzNTJDMTMuNTg5OCAxOS44MzUyIDE0Ljk2OTggMTkuMjY1MiAxNi4wMjk4IDE4LjMzNTJMMTguNjU5OCAyMC45NjUyTDE5LjkyOTggMTkuNjk1Mkw1LjMzOTgyIDUuMTA1MTZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatColorReset = createIcon('FormatColorReset', [
  [
    'path',
    {
      d: 'M18.0698 13.8352C18.0698 9.83516 12.0698 3.03516 12.0698 3.03516C12.0698 3.03516 10.7398 4.54516 9.33982 6.55516L17.9298 15.1452C18.0198 14.7252 18.0698 14.2852 18.0698 13.8352ZM5.33982 5.10516L4.06982 6.38516L7.38982 9.70516C6.61982 11.1552 6.06982 12.6252 6.06982 13.8352C6.06982 17.1452 8.75982 19.8352 12.0698 19.8352C13.5898 19.8352 14.9698 19.2652 16.0298 18.3352L18.6598 20.9652L19.9298 19.6952L5.33982 5.10516Z',
      key: '17a64d',
    },
  ],
]);

export default FormatColorReset;
